export default class Color {
  r: number;
  g: number;
  b: number;
  a: number;

  constructor(r: number, g: number, b: number, a: number) {
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }

  static fromHex(hex: string): Color {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    let a = 1;
    return new Color(r, g, b, a);
  }

  static iosToCssColor(color: string): Color {
    if (!color) {
      console.log("no color");
      color = "FFFFFFFF";
    }
    var pieces = /^(..)(..)(..)(..)$/.exec(color);
    if (pieces == null) {
      var pieces = /^(..)(..)(..)$/.exec(color);
      if (pieces == null) {
        return new Color(255, 255, 255, 1);
      }
      let r = parseInt(pieces[1], 16);
      let g = parseInt(pieces[2], 16);
      let b = parseInt(pieces[3], 16);
      let a = 1;
      return new Color(r, g, b, a);
    }
    var alpha = parseInt(pieces[4], 16) / 255;
    /* console.log('rgba('+parseInt(pieces[1], 16)+','+parseInt(pieces[2], 16)+','+parseInt(pieces[3], 16)+","+alpha+")"); */
    let r = parseInt(pieces[1], 16);
    let g = parseInt(pieces[2], 16);
    let b = parseInt(pieces[3], 16);
    let a = alpha;
    return new Color(r, g, b, a);
  }

  asString(): string {
    return `${this.r}${this.g}${this.b}${this.a}`;
  }

  public asIOS(includingAlpha: boolean = true): string {
    let r = Math.floor(this.r).toString(16);
    r = r.length !== 2 ? `0${r}` : r;
    let g = Math.floor(this.g).toString(16);
    g = g.length !== 2 ? `0${g}` : g;
    let b = Math.floor(this.b).toString(16);
    b = b.length !== 2 ? `0${b}` : b;
    if (!includingAlpha) {
      return `${r}${g}${b}`;
    }
    let a = Math.floor(this.a <= 1 ? this.a * 255 : this.a).toString(16);
    a = a.length !== 2 ? `0${a}` : a;
    let result = `${r}${g}${b}${a}`;
    return result.length !== 8 ? "00000000" : result;
  }

  static default(): Color {
    return new Color(0, 0, 0, 1);
  }

  static fromJSON(json: any): Color {
    return Color.iosToCssColor(json);
  }

  static fromRgbaString(rgba: string): Color {
    const pattern = /rgba\((?<r>\d*.?\d*?),\s?(?<g>\d*.?\d*?),\s?(?<b>\d*.?\d*?),\s?(?<a>\d*.?\d*?)\)/gm;
    const groups = pattern.exec(rgba)!.groups!
    let pieces = {
      r: parseFloat(groups.r),
      g: parseFloat(groups.g),
      b: parseFloat(groups.b),
      a: parseFloat(groups.a),
    }
    return new Color(pieces.r,pieces.g,pieces.b,pieces.a)
  }

  toJSON(): any {
    return this.asIOS();
  }

  asRgba(): string {
    const { r, g, b, a } = this;
    return `rgba(${r},${g},${b},${a.toPrecision(2)})`;
  }

  asHex(includingAlpha: boolean = true): string {
    return `#${this.asIOS(includingAlpha)}`;
  }

  setA(val: number): Color {
    this.a = val;
    return this;
  }

  static black(): Color {
		return new Color(0, 0, 0, 1);
	}

	static white(): Color {
		return new Color(255,255,255, 1);
	}

  equals(other: Color | null): boolean {
    if (!other) return false
    return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a
  }
}

export const TSColor = Color;
